import { gql } from '@apollo/client';

export const INVOICE = gql`
  query INVOICE($id: String!, $lang: String!) {
    invoice(id: $id, lang: $lang)
  }
`;
